<template>
    <div class="authentication-container" >
        <div class="page-info-header">
            <div class="page-info-header-label flex-align-center">
                <!-- <efly-tooltip content="返回" top="34px" left="-15px" placement="bottom" type="white" style="display:inline-block;" v-if="status.type !== 'person'" >
                    <efly-button class="page-info-header-back-btn btn-primary" @click="back()">
                        <i class="icon icon-goback"></i>
                    </efly-button>
                </efly-tooltip> -->
                <i class="icon color-primary icon-ID"></i>
                <span class="mar-l-mini text-color-regular">实名认证信息</span>
            </div>
        </div>

        <div style="overflow-y:auto;max-height:100%;">

            <div class="authentication-content">
                <div class="authentication-block">
                    <div class="block-title mar-b-default">
                        认证信息
                    </div>

                    <div class="mar-b-default" v-if="status.type === 'person'">
                        <efly-tip icon="icon-triangle-plaint " style="display:inline-block!important;">
                            如果您需要升级企业用户，请前往企业实名认证，<span class="color-danger pointer" @click="skip('/authentication')">立即升级企业</span>
                        </efly-tip>
                    </div>


                    <div class="verify-msg box">
                        <div v-if="status.type === 'person'">
                            <p class="msg-line"><span class="label">账户类型</span>个人用户</p>
                            <p class="msg-line"><span class="label">认证账户</span>{{userInfo.email | StarInfoPipe('set')}}</p>
                            <p class="msg-line"><span class="label">真实姓名</span>{{userInfo.trueName | StarInfoPipe('name')}}</p>
                            <p class="msg-line"><span class="label">身份证号</span>{{userInfo.idNumber | StarInfoPipe('set')}}</p>
                            <p class="msg-line"><span class="label">认证时间</span>{{userInfo.verifyRealNameTS || '—'}}</p>
                        </div>
                        <div v-if="status.type !== 'person'">
                            <p class="msg-line"><span class="label">账户类型</span>企业用户</p>
                            <p class="msg-line"><span class="label">认证账户</span>{{userInfo.email | StarInfoPipe('set')}}</p>
                            <p class="msg-line"><span class="label">企业名称</span>{{userInfo.company | StarInfoPipe('set')}}</p>
                            <p class="msg-line"><span class="label">组织机构/社会信用代码</span>{{userInfo.organizationCode | StarInfoPipe('set')}}</p>
                            <p class="msg-line"><span class="label">认证时间</span>{{userInfo.verifyCompanyTS || '—'}}</p>
                        </div>
                        <div v-if="status.type !== 'person'">
                            <p class="msg-line"><span class="label">被授权人真实姓名</span>{{userInfo.corporationName | StarInfoPipe('name')}}</p>
                            <p class="msg-line"><span class="label">被授权人身份号</span>{{userInfo.corporationIDNumber | StarInfoPipe('set')}}</p>
                            <p class="msg-line"><span class="label">信息安全负责人真实姓名</span>{{userInfo.infoSecurityLeaderName | StarInfoPipe('name')}}</p>
                            <p class="msg-line"><span class="label">信息安全负责人身份证号</span>{{userInfo.infoSecurityLeaderIDNumber | StarInfoPipe('set')}}</p>
                        </div>
                        
                    </div>

                </div>
            </div>

            <div class="authentication-content pad-t-0">
                <div class="authentication-block">
                    <div class="block-title mar-b-default">
                        您已实名认证，可选购：
                    </div>

                    <div class="box flex-wrap">
                        <div class="box resource-item" v-for="(item,idx) in resourceList" :key="idx">
                            <div class="box flex-center">
                                <img :src="require('../../../../common/src/assets/image/'+item.img)">
                            </div>
                            <div>
                                <p class="mar-b-xs">{{item.title}}</p>
                                <p class="color-info mar-b-mini">{{item.content}}</p>
                                <efly-button class="btn-primary" size="small" @click="skip(item.link)">立即购买</efly-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import AuthenticationInfo from './authenticationinfo'
export default AuthenticationInfo;
</script>

<style lang="scss" scoped>
    .authentication-container {
        width: 100%;
        background-color: rgb(241, 244, 248);
    }
    .authentication-content {
        padding: 20px;
    }
    .authentication-block {
        background: #fff;
        padding: 20px;

        .block-title {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .verify-msg {
            padding-left: 318px;
            height: 164px;
            font-size: 12px;
            background: url(../../assets/image/verifypage.png) no-repeat;

            & > div {
                width: 380px;
            }

            .msg-line {
                &:not(:first-child) {
                    padding-top: 18px;
                }
                .label {
                    padding-right: 20px;
                    color: #888;
                }
            }
        }
    }

    .resource-item {
        min-width: 360px;
        width: 23%;
        margin-right: 15px;
        margin-bottom: 15px;
        border: 1px solid #ddd;
        padding: 18px 20px 18px 30px;
        font-size: 12px;
        img {
            margin-right: 30px;
        }
    }
</style>